import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { LoginRequest } from './loginrequest';

export class LoginAPI extends APIImpl<LoginRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/subscriber-validation
        return "login";
    }

    getRequestData()
    {
        return "msisdn=" + this.getRequest().getLoginRequest().getMsisdn();
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/login/loginapi.tsx